import { Effect, Predicate } from 'effect';

import { reactivityKeys } from '@vs-shop/engine/atom/reactivityKeys';
import { createCustomerToken } from '../../../bind/customer';
import { RuntimeClientAtom } from '@vs-shop/engine/runtime/RuntimeClient';
import type { CustomerLoginPayload } from '@vs-shop/schemas/customer';
import { AuthToken } from '../../../service/auth/AuthToken';
import { StorageSync } from '../../../service/auth/StorageSync';

export const loginCustomerAtomFn = RuntimeClientAtom.fn(
  Effect.fnUntraced(function* (data: CustomerLoginPayload) {
    const authTokenService = yield* AuthToken;
    const storageSync = yield* StorageSync;
    const response = yield* createCustomerToken(data);

    const { token, refresh_token, refresh_token_expiration } = response;

    if (token && refresh_token && Predicate.isNotNullish(refresh_token_expiration)) {
      yield* authTokenService.setTokens(token, refresh_token, refresh_token_expiration);
      yield* storageSync.broadcastTokensUpdated;
    } else if (token) {
      yield* authTokenService.setToken(token);
    }

    return response;
  }),
  {
    reactivityKeys: [reactivityKeys.authToken, reactivityKeys.customer],
  }
);
